import { render, staticRenderFns } from "./org-plans.vue?vue&type=template&id=64fec190&scoped=true&"
import script from "./org-plans.vue?vue&type=script&lang=js&"
export * from "./org-plans.vue?vue&type=script&lang=js&"
import style0 from "./org-plans.vue?vue&type=style&index=0&id=64fec190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fec190",
  null
  
)

export default component.exports